import { render, staticRenderFns } from "./Pension.vue?vue&type=template&id=eee90548&scoped=true&"
import script from "./Pension.vue?vue&type=script&lang=ts&"
export * from "./Pension.vue?vue&type=script&lang=ts&"
import style0 from "./Pension.vue?vue&type=style&index=0&id=eee90548&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee90548",
  null
  
)

export default component.exports